import { Component } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
	selector: 'yesno',
	templateUrl: './yesNoModal.component.html',
	standalone: false,
})
export class YesNoModalComponent {
	private _texts: any = {};
	private _answer: string;
	private _args: any = {};

	constructor(
		private bsModalRef: BsModalRef
	) {
	}

	yep(): void {
		this._answer = 'yes';
		this.bsModalRef.hide();
	}

	nope(): void {
		this._answer = 'no';
		this.bsModalRef.hide();
	}

	get contextData(): any {
		return this._texts.contextData;
	}

	get texts(): any {
		return this._texts;
	}

	set texts(newTexts: any) {
		this._texts = newTexts;
	}

	get answer(): string {
		return this._answer;
	}
}
